import React from "react";

type AddButtonProps = {
    onClick: () => void;
};

const AddButton: React.FC<AddButtonProps> = ({onClick}) => {
    return (
        <button
            className="flex items-center gap-2 bg-blue-900 text-white px-4 py-2 rounded-lg hover:bg-blue-800 transition"
            onClick={onClick}>
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path strokeWidth={2} d="M12 5v14M5 12h14"/>
            </svg>
            <span>Aggiungi</span>
        </button>
    )
}

export default AddButton;